<template>
  <div class="dashboard-container">
    <h3>{{currentAdvertiser.name}}</h3>
    <router-link to="/ad" exact class="button" tag="button">create ad</router-link>
    <date-range-picker
      :options="{
        autoClose: true,
        changeAction: 'updateCurrentDates',
        customShortcuts: customShortcuts,
        format: 'YYYY-MM-DD',
        formatted: 'L',
        noClearButton: true,
        overlay: true,
      }"
      :timeframe="{ start: allTimeStart, end: allTimeEnd }"
      defaultRangeLabel="all time"
      @updateData="updateData"
    />

    <dashboard-kpis
      prevRangeLabel="prev range"
      :advertiserId="currentAdvertiser.id"
      :dateRange="dateRange"/>

    <div class="table-items-container">
      <sb-tab :tabs="tabs" :selected.sync="selectedTab"/>
      <dashboard-ad-table
        v-if="!isRequestTabSelected"
        ref="dashboardAdTable"
        :currentAdvertiserId="currentAdvertiser.id"
        :dateRange="dateRange"
        :selectedTab="selectedTab"/>
      <dashboard-request-table
        v-else
        ref="dashboardRequestTable"
        :currentAdvertiserId="currentAdvertiser.id"
        :selectedTab="selectedTab"/>
      </div>
  </div>
</template>

<script>
  import DashboardKpis from './DashboardKpis.vue'
  import DashboardAdTable from './DashboardAdTable.vue'
  import DashboardRequestTable from './DashboardRequestTable.vue'
  import DateRangePicker from '../Shared/DateRangePicker'
  import LoadingIcon from '../Shared/LoadingIcon'
  import moment from 'moment'
  import Pagination from '../Shared/Pagination'
  import { NumberFormatters } from '../mixins/NumberFormatters.js'

  export default {
    props: {
      currentAdvertiser: Object,
    },

    name: 'Dashboard',

    mixins: [NumberFormatters],

    components: {
      DateRangePicker,
      LoadingIcon,
      DashboardKpis,
      DashboardAdTable,
      DashboardRequestTable,
      Pagination
    },

    data() {
      return {
        dateRange: null,
        selectedTab: null,
        tabs: [
          { label: "all", key: "all" },
          { label: "sent", key: "sent" },
          { label: "unsent", key: "unsent" },
          { label: "request", key: "request" }
        ]
      }
    },

    created() {
      this.selectedTab = this.tabs[0]
      this.setInitialDateRange()
    },

    computed: {
      allTimeStart() {
        return moment(this.currentAdvertiser.created_at).startOf('day')
      },

      allTimeEnd() {
        return moment().add(1, 'y')
      },

      customShortcuts() {
        const shortcuts = [
          { key: 'allTime', label: 'all time',
            value: () => {
              const start = this.allTimeStart,
                  end = this.allTimeEnd
              return { start, end }
            }
          },
          { key: 'today', label: 'today', value: 'day' },
          { key: 'yesterday', label: 'yesterday', value: '-day' },
          { key: 'thisWeek', label: 'this week', value: 'week' },
          { key: 'lastWeek', label: 'last week', value: '-week' },
          { key: 'thisMonth', label: 'this month', value: 'month' },
          { key: 'lastMonth', label: 'last month', value: '-month' },
          { key: 'thisYear', label: 'this year', value: 'year'},
          { key: 'lastyear', label: 'last year', value: '-year' },
        ]
        return shortcuts
      },

      isRequestTabSelected() {
        return this.selectedTab?.key === 'request'
      },
    },

    methods: {
      setInitialDateRange() {
        const start = this.allTimeStart.unix(),
              end = this.allTimeEnd.unix()
        this.dateRange = { start, end }
      },

      updateData(field, value) {
        this[field] = value
      },
    },
  }
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.dashboard-container
  text-align: center
  padding-top: 2rem
  @media only screen and (max-width: 40em)
    padding-top: 3rem

  h3
    font-size: 1.2rem

  .button
    position: absolute
    right: 2rem
    text-decoration: none
    top: 2rem
    @media only screen and (max-width: 40em)
      right: .25rem
      top: .25rem

.table-items-container
  margin: 4rem auto 4rem auto
  max-width: 1200px

  .sb-tabs
    width: 30%
    margin: 0 auto

    .item
      &.is-active
        span
          background-color: $active-primary-background !important
      &:hover
        &:not(.is-active)
          span
            background: $active-primary-background
</style>